import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { formatMessageWithValues, withModulesManager, withHistory, historyPush } from "@openimis/fe-core";
import ClaimForm from "../components/ClaimForm";
import { createClaim, updateClaim, fetchUserClaimAdmin, selectClaimAdmin } from "../actions";
import { RIGHT_ADD, RIGHT_LOAD } from "../constants";

const styles = (theme) => ({
  page: theme.page,
});

class EditEncounterPage extends Component {
  add = () => {
    historyPush(this.props.modulesManager, this.props.history, "claim.route.encounterEdit");
  };
  autoGenerateClaimCode = this.props.modulesManager.getConf("fe-claim", "claimForm.autoGenerateClaimCode", false);

  componentDidMount() {
    const { claim_uuid, fetchedUserClaimAdmin, userClaimAdmin, claimAdmin, modulesManager } = this.props;
    if (claim_uuid) return;
    if (!fetchedUserClaimAdmin) {
      this.props.fetchUserClaimAdmin(modulesManager);
    } else if (userClaimAdmin && !claimAdmin) {
      this.props.selectClaimAdmin(userClaimAdmin);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.claim_uuid) return;
    if (!prevProps.userClaimAdmin && this.props.userClaimAdmin && !this.props.claimAdmin) {
      this.props.selectClaimAdmin(this.props.userClaimAdmin);
    }
  }

  save = async (claim) => {
    const encounterClaim = { ...claim, visitType: "C" };
    if (!encounterClaim.uuid) {
      return this.props.createClaim(
        this.props.modulesManager,
        encounterClaim,
        formatMessageWithValues(this.props.intl, "claim", "CreateClaim.mutationLabel", {
          code: this.autoGenerateClaimCode ? "Auto" : encounterClaim.code,
        }),
      );
    }
    return this.props.updateClaim(
      this.props.modulesManager,
      encounterClaim,
      formatMessageWithValues(this.props.intl, "claim", "UpdateClaim.mutationLabel", {
        code: encounterClaim.code,
      }),
    );
  };

  render() {
    const { classes, modulesManager, history, rights, claim_uuid } = this.props;
    if (!rights.includes(RIGHT_LOAD)) return null;

    return (
      <div className={classes.page}>
        <ClaimForm
          claim_uuid={claim_uuid}
          back={(e) => {
            if (e && e.preventDefault) e.preventDefault();
            const route = modulesManager.getRef("claim.route.encounter") || "claim/encounters";
            history.push(`/${route}`);
          }}
          add={rights.includes(RIGHT_ADD) ? this.add : null}
          save={rights.includes(RIGHT_LOAD) ? this.save : null}
          isHealthFacilityPage={false}
          isEncounter={true}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
  claim_uuid: props.match.params.claim_uuid,
  path: props.match.path,
  userClaimAdmin: state.claim.userClaimAdmin,
  fetchedUserClaimAdmin: state.claim.fetchedUserClaimAdmin,
  claimAdmin: state.claim.claimAdmin,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ createClaim, updateClaim, fetchUserClaimAdmin, selectClaimAdmin }, dispatch);
};

export default withHistory(
  withModulesManager(
    connect(mapStateToProps, mapDispatchToProps)(injectIntl(withTheme(withStyles(styles)(EditEncounterPage)))),
  ),
);
